import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm$form$enderecos;
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Destinatario",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 1;
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "nome"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "flex-grow-1",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c('VueSelect', {
    ref: "buscarCliente",
    class: {
      hasErrors: _vm.clienteError,
      inputFilled: _vm.clienteFilled
    },
    attrs: {
      "filterable": false,
      "state": _vm.validateClienteState('nome'),
      "options": _vm.clientes,
      "value": _vm.form.nome,
      "clearSearchOnSelect": true
    },
    on: {
      "input": _vm.setCliente,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(_vm._s(option.codigo) + " - " + _vm._s(option.nome))]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("CPF: " + _vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do cliente ")])], 2)], 1), _c('RiscoClienteGrupo', {
    attrs: {
      "cliente": _vm.form
    }
  })], 1)])], 1), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.newClientNfe",
      modifiers: {
        "newClientNfe": true
      }
    }],
    ref: "add_buyer",
    staticClass: "btn btn-primary font-weight-bold w-100",
    staticStyle: {
      "font-size": "11px",
      "margin-top": "30px",
      "white-space": "nowrap"
    }
  }, [_vm._v(" Novo Cliente ")])]), !_vm.form.estrangeiro ? _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CPF/CNPJ",
      "label-for": "cnpj_cpf"
    }
  }, [_vm.hasCnpjAlfanumerico(_vm.form.cnpj_cpf) ? _c('b-form-input', {
    key: "".concat(_vm.keyToReRender, "-alfa"),
    attrs: {
      "disabled": "",
      "id": "cnpj_cpf",
      "name": "cnpj_cpf",
      "value": _vm.formatCnpjAlfanumerico(_vm.form.cnpj_cpf),
      "state": _vm.validateClienteState('cnpj_cpf')
    }
  }) : _c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['###.###.###-##', '##.###.###/####-##'],
      expression: "['###.###.###-##', '##.###.###/####-##']"
    }],
    key: "".concat(_vm.keyToReRender, "-numeric"),
    attrs: {
      "disabled": "",
      "id": "cnpj_cpf",
      "name": "cnpj_cpf",
      "state": _vm.validateClienteState('cnpj_cpf')
    },
    model: {
      value: _vm.form.cnpj_cpf,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cnpj_cpf", $$v);
      },
      expression: "form.cnpj_cpf"
    }
  })], 1)], 1) : _vm._e()], 1), _vm.form.estrangeiro ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Logradouro",
      "label-for": "logradouro_estrangeiro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "logradouro_estrangeiro",
      "name": "logradouro_estrangeiro",
      "disabled": ""
    },
    model: {
      value: _vm.form.logradouro_estrangeiro,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "logradouro_estrangeiro", $$v);
      },
      expression: "form.logradouro_estrangeiro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Número",
      "label-for": "numero_estrangeiro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "numero_estrangeiro",
      "name": "numero_estrangeiro",
      "disabled": ""
    },
    model: {
      value: _vm.form.numero_estrangeiro,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "numero_estrangeiro", $$v);
      },
      expression: "form.numero_estrangeiro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bairro",
      "label-for": "bairro_estrangeiro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "bairro_estrangeiro",
      "name": "bairro_estrangeiro",
      "disabled": ""
    },
    model: {
      value: _vm.form.bairro_estrangeiro,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bairro_estrangeiro", $$v);
      },
      expression: "form.bairro_estrangeiro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "UF",
      "label-for": "uf_estrangeiro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "uf_estrangeiro",
      "name": "uf_estrangeiro",
      "disabled": ""
    },
    model: {
      value: _vm.form.uf_estrangeiro,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "uf_estrangeiro", $$v);
      },
      expression: "form.uf_estrangeiro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "País",
      "label-for": "pais_estrangeiro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "pais_estrangeiro",
      "name": "pais_estrangeiro",
      "disabled": ""
    },
    model: {
      value: _vm.form.pais_estrangeiro,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pais_estrangeiro", $$v);
      },
      expression: "form.pais_estrangeiro"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.form.estrangeiro && _vm.store.formNatureza.cfop.substring(0, 1) === '7' ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Local do embarque",
      "label-for": "local_embarque"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "local_embarque",
      "name": "local_embarque"
    },
    model: {
      value: _vm.form.local_embarque,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "local_embarque", $$v);
      },
      expression: "form.local_embarque"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "1"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "UF",
      "label-for": "uf_embarque"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "uf_embarque",
      "name": "uf_embarque"
    },
    model: {
      value: _vm.form.uf_embarque,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "uf_embarque", $$v);
      },
      expression: "form.uf_embarque"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Local do despacho",
      "label-for": "local_despacho"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "local_despacho",
      "name": "local_despacho"
    },
    model: {
      value: _vm.form.local_despacho,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "local_despacho", $$v);
      },
      expression: "form.local_despacho"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.isCnpjValue(_vm.form.cnpj_cpf) ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "identificador_ie",
      "label-for": "identificador_ie",
      "label": "Indicador de IE"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.identificador_ie,
      expression: "form.identificador_ie"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "identificador_ie",
      "id": "identificador_ie"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "identificador_ie", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        return _vm.setIe();
      }]
    }
  }, _vm._l(_vm.identificadores_ie, function (i, index) {
    return _c('option', {
      key: 'identificador' + index,
      domProps: {
        "value": i.id
      }
    }, [_vm._v(" " + _vm._s(i.descricao) + " ")]);
  }), 0)])], 1), _c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "IE",
      "label-for": "ie_rg"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['#################'],
      expression: "['#################']"
    }],
    key: _vm.keyToReRender,
    attrs: {
      "id": "ie_rg",
      "name": "ie_rg"
    },
    model: {
      value: _vm.form.ie_rg,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ie_rg", $$v);
      },
      expression: "form.ie_rg"
    }
  })], 1)], 1)], 1) : _vm._e(), !_vm.form.estrangeiro ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-group', {
    key: _vm.keyToReRender,
    attrs: {
      "label": "Endereço",
      "label-for": "endereco"
    }
  }, [_c('VueSelect', {
    ref: "endereco",
    class: {
      hasErrors: _vm.enderecoError,
      inputFilled: _vm.enderecoFilled
    },
    attrs: {
      "filterable": false,
      "options": _vm.enderecos,
      "value": _vm.formatEndereco(_vm.form.endereco),
      "state": _vm.validateClienteState('endereco')
    },
    on: {
      "input": _vm.setEndereco,
      "search": _vm.onSearchEndereco
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        var _option$cep, _option$logradouro, _option$numero, _option$complemento, _option$bairro, _option$cidade$cidade, _option$cidade, _option$cidade$uf, _option$cidade2;
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s("".concat((_option$cep = option.cep) !== null && _option$cep !== void 0 ? _option$cep : "", ", ").concat((_option$logradouro = option.logradouro) !== null && _option$logradouro !== void 0 ? _option$logradouro : "", ", ").concat((_option$numero = option.numero) !== null && _option$numero !== void 0 ? _option$numero : "", ", ").concat((_option$complemento = option.complemento) !== null && _option$complemento !== void 0 ? _option$complemento : "", ", ").concat((_option$bairro = option.bairro) !== null && _option$bairro !== void 0 ? _option$bairro : "", " - ").concat((_option$cidade$cidade = option === null || option === void 0 || (_option$cidade = option.cidade) === null || _option$cidade === void 0 ? void 0 : _option$cidade.cidade) !== null && _option$cidade$cidade !== void 0 ? _option$cidade$cidade : "", " / ").concat((_option$cidade$uf = option === null || option === void 0 || (_option$cidade2 = option.cidade) === null || _option$cidade2 === void 0 ? void 0 : _option$cidade2.uf) !== null && _option$cidade$uf !== void 0 ? _option$cidade$uf : "")) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }], null, false, 3226507635)
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o Endereço ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('button', {
    staticClass: "btn btn-light-primary font-weight-bold w-100",
    staticStyle: {
      "font-size": "11px",
      "margin-top": "30px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.form.id_pessoa || !_vm.form.endereco
    },
    on: {
      "click": _vm.abrirModalEditarEndereco
    }
  }, [_vm._v(" Editar endereço ")])])], 1) : _vm._e(), !_vm.form.estrangeiro ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "10"
    }
  }, [_c('b-form-group', {
    key: _vm.keyToReRender,
    attrs: {
      "label": "Endereço de entrega",
      "label-for": "enderecoEntrega"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" Endereço de entrega "), _c('b-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Selecionar somente se for fazer entrega em outro local',
            expression: "\n              'Selecionar somente se for fazer entrega em outro local'\n            "
          }],
          attrs: {
            "icon": "info-circle",
            "variant": "primary"
          }
        })];
      },
      proxy: true
    }], null, false, 1891094)
  }, [_c('VueSelect', {
    ref: "enderecoEntrega",
    attrs: {
      "filterable": false,
      "options": _vm.enderecos,
      "value": _vm.formatEnderecoEntrega(_vm.form.enderecoEntrega)
    },
    on: {
      "input": _vm.setEnderecoEntrega,
      "search": _vm.onSearchEndereco
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        var _option$cep2, _option$logradouro2, _option$numero2, _option$complemento2, _option$bairro2, _option$cidade$cidade2, _option$cidade3, _option$cidade$uf2, _option$cidade4;
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s("".concat((_option$cep2 = option.cep) !== null && _option$cep2 !== void 0 ? _option$cep2 : "", ", ").concat((_option$logradouro2 = option.logradouro) !== null && _option$logradouro2 !== void 0 ? _option$logradouro2 : "", ", ").concat((_option$numero2 = option.numero) !== null && _option$numero2 !== void 0 ? _option$numero2 : "", ", ").concat((_option$complemento2 = option.complemento) !== null && _option$complemento2 !== void 0 ? _option$complemento2 : "", ", ").concat((_option$bairro2 = option.bairro) !== null && _option$bairro2 !== void 0 ? _option$bairro2 : "", " - ").concat((_option$cidade$cidade2 = option === null || option === void 0 || (_option$cidade3 = option.cidade) === null || _option$cidade3 === void 0 ? void 0 : _option$cidade3.cidade) !== null && _option$cidade$cidade2 !== void 0 ? _option$cidade$cidade2 : "", " / ").concat((_option$cidade$uf2 = option === null || option === void 0 || (_option$cidade4 = option.cidade) === null || _option$cidade4 === void 0 ? void 0 : _option$cidade4.uf) !== null && _option$cidade$uf2 !== void 0 ? _option$cidade$uf2 : "")) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }], null, false, 3226507635)
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o Endereço ")])], 2)], 1)], 1)], 1) : _vm._e(), !_vm.form.estrangeiro ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "5"
    }
  }, [_c('b-form-group', {
    key: _vm.keyToReRender,
    attrs: {
      "label": "E-mail",
      "label-for": "email"
    }
  }, [_c('VueSelect', {
    ref: "buscarNatureza",
    class: {
      hasErrors: _vm.emailError,
      inputFilled: _vm.emailFilled
    },
    attrs: {
      "filterable": false,
      "options": _vm.emails,
      "value": _vm.form.email
    },
    on: {
      "input": _vm.setEmail,
      "search": _vm.onSearchEmail
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.email) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.email) + " ")])];
      }
    }], null, false, 2808537348)
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o E-mail ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "5"
    }
  }, [_c('b-form-group', {
    key: _vm.keyToReRender,
    attrs: {
      "label": "Telefone",
      "label-for": "fone"
    }
  }, [_c('VueSelect', {
    ref: "fone",
    attrs: {
      "filterable": false,
      "options": _vm.fones
    },
    on: {
      "input": _vm.setFone
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.fone) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.fone) + " ")])];
      }
    }], null, false, 3453882852),
    model: {
      value: _vm.form.fone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fone", $$v);
      },
      expression: "form.fone"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o Telefone ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Contato",
      "label-for": "contato"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "contato",
      "name": "contato",
      "state": _vm.validateClienteState('contato')
    },
    model: {
      value: _vm.form.contato,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "contato", $$v);
      },
      expression: "form.contato"
    }
  })], 1)], 1), _vm.form.tipo_atacado ? _c('b-col', {
    staticStyle: {
      "margin-top": "35px"
    },
    attrs: {
      "sm": "2"
    }
  }, [_c('span', {
    staticClass: "label label-lg label-inline label-light-warning"
  }, [_vm._v("Tipo Atacado")])]) : _vm._e()], 1) : _vm._e(), _vm.limiteCreditoAtigindo ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('span', {
    staticClass: "label label-lg label-inline label-light-danger"
  }, [_vm._v("Limite de crédito atingido")]), _vm._v(" - "), _c('span', [_c('strong', [_vm._v("Limite: R$ " + _vm._s(_vm.numberToReal(_vm.valorLimiteCredito, 2)))])]), _vm._v(" / "), _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.righttop",
      value: 'O limite de crédito considera contas a receber na situação (Em aberto)',
      expression: "\n          'O limite de crédito considera contas a receber na situação (Em aberto)'\n        ",
      modifiers: {
        "righttop": true
      }
    }]
  }, [_c('strong', [_vm._v("Atingido: R$ " + _vm._s(_vm.numberToReal(_vm.valorLimiteCreditoAtingido, 2)))])])])], 1) : _vm._e(), _vm.form.produtor_rural && _vm.store.tpNF == 0 ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Número",
      "label-for": "numeroNF"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "numeroNF",
      "name": "numeroNF",
      "type": "number"
    },
    model: {
      value: _vm.rural.numeroNF,
      callback: function callback($$v) {
        _vm.$set(_vm.rural, "numeroNF", $$v);
      },
      expression: "rural.numeroNF"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Série",
      "label-for": "serie"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "serie",
      "name": "serie",
      "type": "number"
    },
    model: {
      value: _vm.rural.serie,
      callback: function callback($$v) {
        _vm.$set(_vm.rural, "serie", $$v);
      },
      expression: "rural.serie"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Selecione o modelo",
      "label-for": "modelo"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.rural.modelo,
      expression: "rural.modelo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "modelo",
      "id": "modelo"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.rural, "modelo", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.modelosProdutor, function (m, index) {
    return _c('option', {
      key: 'id' + index,
      domProps: {
        "value": m.modelo
      }
    }, [_vm._v(" " + _vm._s(m.modelo) + " ")]);
  }), 0)])], 1), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Mês",
      "label-for": "mes"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '##',
      expression: "'##'"
    }],
    attrs: {
      "id": "mes",
      "name": "mes"
    },
    model: {
      value: _vm.rural.mes,
      callback: function callback($$v) {
        _vm.$set(_vm.rural, "mes", $$v);
      },
      expression: "rural.mes"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Ano",
      "label-for": "ano"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '####',
      expression: "'####'"
    }],
    attrs: {
      "id": "ano",
      "name": "ano"
    },
    model: {
      value: _vm.rural.ano,
      callback: function callback($$v) {
        _vm.$set(_vm.rural, "ano", $$v);
      },
      expression: "rural.ano"
    }
  })], 1)], 1), _vm.rural.modelo == 55 ? _c('b-col', {
    attrs: {
      "sm": "10"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Chave de Acesso da NFe",
      "label-for": "chave"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "chave",
      "name": "chave",
      "type": "number",
      "formatter": _vm.formatKeyProdutor
    },
    model: {
      value: _vm.rural.chave,
      callback: function callback($$v) {
        _vm.$set(_vm.rural, "chave", $$v);
      },
      expression: "rural.chave"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.listaPreco ? _c('b-row', [_c('b-col', [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" Lista de preço aplicada: "), _c('span', {
    staticClass: "font-weight-bold text-primary"
  }, [_vm._v(_vm._s(_vm.listaPreco.descricao))])])])], 1) : _vm._e(), _vm.isCnpjValue(_vm.form.cnpj_cpf) ? _c('b-row', [_c('b-col', [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" Tributação/Revenda: "), _c('b-icon', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: 'Ao selecionar essa opção irá buscar a tributação de revenda',
      expression: "\n            'Ao selecionar essa opção irá buscar a tributação de revenda'\n          "
    }],
    attrs: {
      "icon": "info-circle",
      "variant": "primary"
    }
  }), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.tributacao_revenda,
      expression: "form.tributacao_revenda"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.tributacao_revenda) ? _vm._i(_vm.form.tributacao_revenda, null) > -1 : _vm.form.tributacao_revenda
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.tributacao_revenda,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "tributacao_revenda", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "tributacao_revenda", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "tributacao_revenda", $$c);
        }
      }
    }
  }), _c('span')])])], 1)])], 1) : _vm._e(), _c('NovoClienteModal', {
    attrs: {
      "modal-id": "newClientNfe"
    },
    on: {
      "selected": _vm.handleNovoClienteSelected
    }
  }), _c('SelecionarInscricaoEstadualModal', {
    ref: "selecaoIeModal",
    attrs: {
      "modal-id": "selecaoIeNfe",
      "ie-principal": _vm.form.ie_rg,
      "endereco-principal": ((_vm$form$enderecos = _vm.form.enderecos) === null || _vm$form$enderecos === void 0 ? void 0 : _vm$form$enderecos[0]) || _vm.form.endereco || null,
      "inscricoes-adicionais": _vm.form.inscricoes_estaduais
    },
    on: {
      "selected": _vm.handleSelecaoInscricaoEstadual
    }
  }), _c('b-modal', {
    attrs: {
      "id": "editAddressNfe",
      "size": "lg",
      "centered": "",
      "title": "Editar endereço"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click() {
              cancel();
              _vm.resetEnderecoEditadoForm();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "saveAddress",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.salvarEnderecoCliente
          }
        }, [_vm._v(" Salvar ")])];
      }
    }])
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CEP",
      "label-for": "editarEnderecoCep"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['#####-###'],
      expression: "['#####-###']"
    }],
    attrs: {
      "id": "editarEnderecoCep",
      "name": "editarEnderecoCep"
    },
    model: {
      value: _vm.enderecoEditado.cep,
      callback: function callback($$v) {
        _vm.$set(_vm.enderecoEditado, "cep", $$v);
      },
      expression: "enderecoEditado.cep"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.consultaCepEnderecoEditado
    }
  }, [_vm._v(" Consultar CEP ")])])], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Número",
      "label-for": "editarEnderecoNumero"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "editarEnderecoNumero",
      "name": "editarEnderecoNumero"
    },
    model: {
      value: _vm.enderecoEditado.numero,
      callback: function callback($$v) {
        _vm.$set(_vm.enderecoEditado, "numero", $$v);
      },
      expression: "enderecoEditado.numero"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bairro",
      "label-for": "editarEnderecoBairro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "editarEnderecoBairro",
      "name": "editarEnderecoBairro"
    },
    model: {
      value: _vm.enderecoEditado.bairro,
      callback: function callback($$v) {
        _vm.$set(_vm.enderecoEditado, "bairro", $$v);
      },
      expression: "enderecoEditado.bairro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Logradouro",
      "label-for": "editarEnderecoLogradouro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "editarEnderecoLogradouro",
      "name": "editarEnderecoLogradouro"
    },
    model: {
      value: _vm.enderecoEditado.logradouro,
      callback: function callback($$v) {
        _vm.$set(_vm.enderecoEditado, "logradouro", $$v);
      },
      expression: "enderecoEditado.logradouro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Complemento",
      "label-for": "editarEnderecoComplemento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "editarEnderecoComplemento",
      "name": "editarEnderecoComplemento"
    },
    model: {
      value: _vm.enderecoEditado.complemento,
      callback: function callback($$v) {
        _vm.$set(_vm.enderecoEditado, "complemento", $$v);
      },
      expression: "enderecoEditado.complemento"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cidade",
      "label-for": "editarEnderecoCidade"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "cidade",
      "options": _vm.cidadesEnderecoEditado
    },
    on: {
      "input": _vm.setCidadeEnderecoEditado,
      "search": _vm.onSearchCidadeEnderecoEditado
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.cidade + " - " + option.uf) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.cidade + " - " + option.uf) + " ")])];
      }
    }]),
    model: {
      value: _vm.cidadeEnderecoEditado,
      callback: function callback($$v) {
        _vm.cidadeEnderecoEditado = $$v;
      },
      expression: "cidadeEnderecoEditado"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome da cidade ")])], 2)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };